var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1804,
    height: 1171,
    viewBox: "0 0 1804 1171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    transform: "translate(0 142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1407.019,
    cy: 290,
    fill: "#F05B5C",
    fillRule: "nonzero",
    rx: 13.002,
    ry: 13
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1190.225,
    cy: 75,
    fill: "#F9BB40",
    fillRule: "nonzero",
    rx: 11.502,
    ry: 11.5,
    transform: "matrix(-1 0 0 1 2380.45 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 475.138,
    cy: 81,
    fill: "#F28A21",
    fillRule: "nonzero",
    rx: 11.002,
    ry: 11
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 711.137,
    cy: 13,
    fill: "#FFDC95",
    fillRule: "nonzero",
    rx: 7.001,
    ry: 7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124,
    cy: 14,
    r: 14,
    fill: "#F28A21",
    fillRule: "nonzero",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 177,
    r: 32,
    fill: "#FFDC95",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1068.725,
    cy: 623.5,
    fill: "#FFDC95",
    fillRule: "nonzero",
    rx: 13.002,
    ry: 13,
    transform: "matrix(-1 0 0 1 2137.45 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 735.181,
    cy: 500.5,
    fill: "#F9BB40",
    fillRule: "nonzero",
    rx: 8.502,
    ry: 8.5,
    transform: "matrix(-1 0 0 1 1470.362 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.002,
    cy: 342,
    fill: "#B1B1B1",
    fillRule: "nonzero",
    rx: 9.002,
    ry: 9,
    transform: "matrix(-1 0 0 1 134.003 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 252.5,
    r: 17.5,
    fill: "#F05B5C",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 567 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1755.252,
    cy: 41.25,
    fill: "#FFDC95",
    fillRule: "nonzero",
    rx: 14.252,
    ry: 14.25
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1719.348,
    cy: 425.5,
    fill: "#FFDC95",
    fillRule: "nonzero",
    rx: 9.002,
    ry: 9
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 307,
    cy: 629,
    r: 5,
    fill: "#A80000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 872,
    r: 6,
    fill: "#F05B5C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1775,
    cy: 385,
    r: 18,
    fill: "#FFF",
    transform: "matrix(-1 0 0 1 3550 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 457.002,
    cy: 1016,
    fill: "#D12A44",
    fillRule: "nonzero",
    rx: 13.002,
    ry: 13,
    transform: "matrix(-1 0 0 1 914.004 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.002,
    cy: 902,
    fill: "#B1B1B1",
    fillRule: "nonzero",
    opacity: 0.75,
    rx: 10.002,
    ry: 10,
    transform: "matrix(-1 0 0 1 592.003 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 146.252,
    cy: 747.247,
    fill: "#D9D9D9",
    opacity: 0.75,
    rx: 26.252,
    ry: 26.247,
    transform: "matrix(-1 0 0 1 292.504 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1716,
    cy: 848,
    r: 13,
    fill: "#F28A21",
    fillRule: "nonzero",
    opacity: 0.25,
    transform: "matrix(-1 0 0 1 3432 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1565,
    cy: 975,
    r: 17,
    fill: "#F05B5C",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 3130 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 633.997,
    fill: "#FFDC95",
    fillRule: "nonzero",
    rx: 16,
    ry: 15.997,
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1484,
    cy: 786,
    r: 25,
    fill: "#D9D9D9",
    fillRule: "nonzero",
    transform: "matrix(-1 0 0 1 2968 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.028ca7cf545f87ae6cec9603b0baca0e.svg";
export { ForwardRef as ReactComponent };